import { ApiParams } from '@/core/http/ApiResource';
import { User, UserResource } from '@/modules/user/User';
import PaginatedResponse from '@/core/http/PaginatedResponse';

export class CustomerUserResource extends UserResource {
	private readonly customerId: number | string;

	constructor(customerId: number | string) {
		super('/api/user');

		this.customerId = customerId;
	}

	async getAll(params: ApiParams = {}, withLoader: boolean = this.withLoader): Promise<PaginatedResponse<User>> {
		return this.getAllRequest(`/api/customer/${this.customerId}/user`, params, withLoader);
	}

	post(data: Partial<User>, withLoader: boolean = this.withLoader): Promise<User> {
		return this.getApi(withLoader)
			.post<User>(`/api/customer/${this.customerId}/user`, data)
		;
	}
}

export const useCustomerUser = (customerId: number | string) => new CustomerUserResource(customerId);
